<template>
    <v-chart v-loading="loading" ref="chart" class="chart" :option="option" />
</template>

<script>
export default {
    name: 'analysisHospitalPieChart',
    props: {
        id: {
            type: [String, Number, Object]
        }
    },
    data() {
        return {
            loading: false,
            option: {
                title: {
                    text: '来源机构占比',
                    left: 'center'
                },
                color: ['#FCCE10', '#E87C25', '#de6e6a', '#5971c0', '#B5C334'],
                tooltip: {
                    trigger: 'item',
                    formatter: '{b} : {c} ({d}%)'
                },
                series: [
                    {
                        type: 'pie',
                        radius: '55%',
                        center: ['50%', '60%'],
                        data: [
                        ],
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ]
            }
        }
    },
    methods: {
        async getData() {
            this.loading = true
            const resp = await this.$http.get(`/statistics/analysis_hospital_pie_chart?id=${this.id}`)
            this.option.series[0].data = resp.data
            this.$refs['chart'].setOption(this.option)
            this.loading = false
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.$refs.chart.resize()
        })
        window.addEventListener('resize', ()=>{
            if (this.$refs && this.$refs.chart) {
                this.$refs.chart.resize()
            }
        })
        this.getData()
    }
}
</script>

<style scoped>
.chart {
    width: 100%;
    height: 400px;
}
</style>
